//@flow
import {buildRoute} from '../../../http';
import {
  addProductImageApi,
  endpoints,
  getProductTaxesApi,
  getTaxesApi,
  saveProductVariantOptionApi,
  getProductVariantOptionApi,
  updateProductVariantOptionApi,
  getProductSectionsApi,
  getProductMetadataSettingApi,
  editProductApi,
  getProductsApi,
  setProductTaxApi,
} from '../api';

import type {ProductRequest} from '../api';
import type {
  MinimalProduct,
  Pagination,
  ProductFilterParams,
  ProductVariantOption,
  ProductSection,
  ProductMetaDataSetting,
  PaginationResponse,
  Product,
} from '../../../entities';

export function changeProductImageService(productId: string, images: string[]) {
  return addProductImageApi(
    {fileIds: images},
    {
      route: buildRoute(endpoints.ADD_PRODUCT_IMAGE, [productId]),
    }
  ).toPromise();
}

export function getProductTaxesService(productId: string) {
  return getProductTaxesApi(undefined, {
    route: buildRoute(endpoints.GET_PRODUCT_TAXES, [productId]),
  }).toPromise();
}

export function getTaxesService(queryFilter?: {[key: string]: any}) {
  return getTaxesApi(queryFilter).toPromise();
}
type Response = {
  data: MinimalProduct[],
  pagination: Pagination,
};

export function searchProductsMinimalService(
  search: string,
  params?: ProductFilterParams = {}
): Promise<Response> {
  return getProductsApi({
    name: search,
    product_type: 'MINIMAL',
    ...params,
  }).toPromise();
}

export function getProductsMinimalService(
  params?: ProductFilterParams = {}
): Promise<Response> {
  // $FlowFixMe
  return getProductsApi({product_type: 'MINIMAL', ...params}).toPromise();
}

//sections

export function getProductSectionsService(
  productId: string
): Promise<ProductSection[]> {
  return getProductSectionsApi(undefined, {
    route: buildRoute(endpoints.GET_PRODUCT_SECTIONS, [productId]),
  }).toPromise();
}

// variants
export function saveProductVariantOptionService(variantOption: {
  [key: string]: any,
}) {
  return saveProductVariantOptionApi(variantOption).toPromise();
}

export function getProductVariantOptionService(
  id: string
): Promise<ProductVariantOption> {
  return getProductVariantOptionApi(undefined, {
    route: buildRoute(endpoints.GET_PRODUCT_VARIANT_OPTION, [id]),
  }).toPromise();
}

export function updateProductVariantOptionService(
  body: {[key: string]: any},
  id: string
): Promise<ProductVariantOption> {
  return updateProductVariantOptionApi(body, {
    route: buildRoute(endpoints.GET_PRODUCT_VARIANT_OPTION, [id]),
  }).toPromise();
}

export function editProductService(productId: string, request: ProductRequest) {
  return editProductApi(request, {
    route: buildRoute(endpoints.EDIT_PRODUCT, [productId]),
  }).toPromise();
}

export function getProductMetadataSettingService(
  productId: string
): Promise<ProductMetaDataSetting> {
  return getProductMetadataSettingApi(undefined, {
    route: buildRoute(endpoints.GET_METADATA_SETTING, [productId]),
  }).toPromise();
}

export type ListProductsParams = {
  enabled?: '1' | '0',
  featured?: '1' | '0',
  has_stock?: '1' | '0',
  has_bulk_price?: '1' | '0',
  name?: string,
  categories?: string[],
  promotions?: string[],
  variant_options?: string[],
  variant_option_values?: string[],
  page?: number,
  size?: number,
  product_type?: 'FULL',
  sort?: 'NAME' | 'PRICE',
  order?: 'ASC' | 'DESC',
};

const defaultListProductsParams = {
  page: 0,
  size: 10,
};

export function listProductsService(
  params?: ListProductsParams
): Promise<PaginationResponse<Product>> {
  const parsedParams = Object.entries(params || {}).reduce(
    (acc, [key, value]) => {
      if (!value) {
        return acc;
      }

      const valueType = typeof value;

      if (valueType === 'string' || valueType === 'number') {
        acc[key] = value;
      }

      if (Array.isArray(value)) {
        acc[key] = value.join(',');
      }

      return acc;
    },
    {}
  );

  const queryParams = {...defaultListProductsParams, ...parsedParams};

  return getProductsApi(queryParams).toPromise();
}

export function setProductTaxService(
  productId: string,
  taxId: string
): Promise<Product> {
  return setProductTaxApi(
    {
      productId,
    },
    {
      route: buildRoute(endpoints.SET_PRODUCT_TAX, [taxId]),
    }
  ).toPromise();
}
